import { render, staticRenderFns } from "./Anuncios.vue?vue&type=template&id=622f1e3a&"
import script from "./Anuncios.vue?vue&type=script&lang=js&"
export * from "./Anuncios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports